import { render, staticRenderFns } from "./set-batch.vue?vue&type=template&id=98caed50&scoped=true"
import script from "./set-batch.vue?vue&type=script&lang=js"
export * from "./set-batch.vue?vue&type=script&lang=js"
import style0 from "./set-batch.vue?vue&type=style&index=0&id=98caed50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98caed50",
  null
  
)

export default component.exports